import React from 'react';
import { ConfirmModal, useModalContext } from '@fourthwall/components';
import cartAbandonmentEmailPromoImage from '../../../../Recommendations/modules/CartAbandonmentEmailPromoRecommendation/assets/cart-abandonment-email-promo.png';
import * as S from './ConfirmEmailPromoCodeModal.styled';
export const ConfirmEmailPromoCodeModal = ({ onConfirm }) => {
    const { close } = useModalContext();
    return (React.createElement(ConfirmModal, { text: React.createElement(S.Container, null,
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { src: cartAbandonmentEmailPromoImage, alt: "Cart abandonment email promo" })),
            React.createElement(S.Content, null,
                React.createElement(S.Title, null, "Boost sales with a discount in abandoned checkout emails"),
                React.createElement("p", null, "Increase your checkout recovery rate up to 40% when you offer a a discount code in abandoned checkout reminder emails"))), confirmLabel: "Offer free shipping on large orders", confirmButtonAnalytics: "abandonmentDiscount", onConfirm: onConfirm, onCancel: close, close: close, title: "" }));
};
